import React from 'react'

import './Disclaimer.css'

const Disclaimer = () => {
  const disclaimer = process.env.REACT_APP_DISCLAIMER

  if (disclaimer && disclaimer.length > 0) {
    return <p className="mx-auto mb-5 Disclaimer">{disclaimer}</p>
  } else {
    return null
  }
}

export default Disclaimer



// WEBPACK FOOTER //
// ./src/components/Footer/Disclaimer/Disclaimer.js